import api from '../services/api';
import { barProgressReward } from './bar-reward';
import { $Q, $Qll } from '../utils/query-selector';
import { dataToggle, toggleDataActive } from '../utils/toggle-dataset';
import {
  updateCartItems,
  updatetotalPrice,
  updateCartbutton,
  updatePriceItem,
  updateUpsell,
  updateCountCart,
} from './update-cart';
import {
  sliderReassurance,
  sliderUpsell,
  sliderUpsellMeta,
  sliderUpsellVertical,
} from './slider-swiper';
import { validationTC } from './validate-tc';
import { addMinutes, startTimer } from './timer';

const CART_SECTION = 'side-cart,cart-page';

sliderUpsell();
sliderReassurance();
validationTC();
sliderUpsellMeta();
sliderUpsellVertical();

/**
 * Add products in cart
 * @param {event} event -Event submit from add to cart form
 */
// eslint-disable-next-line complexity
export const addProducts = async (event) => {
  let itemId = 0;

  if (event.target) {
    const radio = event.target.querySelector('input:checked');
    if (radio) {
      itemId = radio.value;
    } else {
      for (const input of event.target) {
        if (input.name === 'id') {
          itemId = input.value;
        }
      }
    }
  } else {
    itemId = $Q('input[name="id"]', event).value;
  }

  const cartParams = {
    items: [
      {
        id: itemId,
        quantity: 1,
      },
    ],
    sections: CART_SECTION,
  };

  const { sections = null } = await api.addToCart(cartParams);
  if (!sections) return null;

  if (event.target) {
    if (event.target.dataset.form !== 'upsell') {
      dataToggle($Q('#shopify-section-side-cart'), true);
    }
  } else {
    dataToggle($Q('#shopify-section-side-cart'), true);
  }

  addMinutes();
  startTimer(true);

  updateCartItems(sections['side-cart']);
  updateCartbutton(sections['side-cart']);
  updatetotalPrice(sections['side-cart']);
  updateUpsell(sections['side-cart']);
  updateCountCart(sections['side-cart']);
};

const submitForm = (form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    // AB TEST
    // addProducts(e);

    // Remove this after AB TEST
      // eslint-disable-next-line no-param-reassign
      form.method = 'POST'
      // eslint-disable-next-line no-param-reassign
      form.action = '/cart/add'
      form.submit()
  });
};

/**
 * Listen if add to cart form is submited
 * if add to cart form is submited add products in cart
 *
 * @param {string} formQuery - className reference in form add-to-cart
 *
 * To active this feature - ADD className 'add-cart-js' in form product
 * */
export const btnAddToCart = (formQuery) => {
  const addForms = $Qll(formQuery);

  if (addForms != null) {
    addForms.forEach((form) => {
      submitForm(form);
    });
  }
};

/**
 * Event add product reward
 */
export const addRewardProduct = async (
  itemsIds,
  listerner = false,
  setTime = false
) => {
  document.querySelector('.cart-loader').classList.add('active');

  const { sections } = await api.updateCart(itemsIds, CART_SECTION);
  if (!sections) return null;

  if (listerner) {
    recommendedProduct();
  }

  updatetotalPrice(sections['side-cart']);
  updateCartbutton(sections['side-cart']);
  updateCartItems(sections['side-cart']);
  updateUpsell(sections['side-cart']);
  updateCountCart(sections['side-cart']);

  if (setTime === true) {
    addMinutes();
    startTimer();
  }

  document.querySelector('.cart-loader').classList.remove('active');
};

/**
 * Replace en element with a spinner
 * @param {String} element
 */
const addSpinner = (element) => {
  if (element) {
    $Q(element).innerHTML = '<div class="loading"></div>';
  }
};

/**
 * Update quantity for each item in cart
 * @param {number} id Product ID
 * @param {number} quantity new quantity
 */
export const updateCart = async (line, quantity, id) => {
  document.querySelector('.cart-loader').classList.add('active');

  const cartParams = {
    line,
    quantity,
    sections: CART_SECTION,
  };

  const { sections = null } = await api.changeCart(cartParams);

  if (!sections) return null;

  if (Number(quantity) === 0) {
    updateCartItems(sections['side-cart']);
    updateCartbutton(sections['side-cart']);
    updatetotalPrice(sections['side-cart']);
    updateUpsell(sections['side-cart']);
  } else {
    updatePriceItem(sections['side-cart'], id);
    updateCartbutton(sections['side-cart']);
    updatetotalPrice(sections['side-cart']);
  }

  updateCountCart(sections['side-cart']);

  addMinutes();
  startTimer();

  document.querySelector('.cart-loader').classList.remove('active');
};

/**
 * change checkbox selected or no
 * @param {event} e - event change input
 */
const changeSelectCheck = async (e) => {
  const idProduct = e.target.value;
  if (e.target.checked) {
    await addRewardProduct({ [idProduct]: 1 });
    return;
  }
  addRewardProduct({ [idProduct]: 0 }, false);
};

/**
 * init event change add product recommended checkbox
 */
export const recommendedProduct = () => {
  const elements = $Qll('.recommended');

  elements.forEach((element) => {
    const checkField = $Q('input[type=checkbox]', element);
    checkField.addEventListener('change', (event) => {
      changeSelectCheck(event);
    });
  });
};

/**
 * Event onChange in the cart item
 */
export const onChangeItemCart = () => {
  $Qll('.item-cart-js').forEach((input) => {
    input.addEventListener('change', function () {
      updateCart(this.dataset.index, this.value, this.id);
    });
  });
};

/**
 * Delete item in cart
 * listen if delete button is clicked
 * if is clicked, update cart with quantity 0
 */
export const deleteItem = () => {
  const deleteIcon = $Qll('.item-delete');

  if (deleteIcon) {
    deleteIcon.forEach((element) => {
      const {
        dataset: { id, index },
      } = element;
      element.addEventListener('click', () => {
        updateCart(index, 0, `${id}-${index}`);
      });
    });
  }
};

/**
 * Delete item in cart
 * listen if delete button is clicked
 * if is clicked, update cart with quantity 0
 */
export const deleteAllItems = async () => {
  const deleteIcon = $Qll('.item-delete');

  // eslint-disable-next-line guard-for-in
  for (const item in deleteIcon) {
    // eslint-disable-next-line no-await-in-loop
    await addRewardProduct({ [deleteIcon[item].dataset.id]: 0 }, true);
  }

  const cartEmpty = $Q('.cart-items__empty');
  const prowresComponent = $Q('.reward-js');

  if (!cartEmpty) {
    prowresComponent.classList.remove('hidden');
  } else {
    prowresComponent.classList.add('hidden');
  }
};

/**
 * Open and close side cart with various buttons
 */
export const openCloseCart = () => {
  const cartContainer = $Q('.cart');
  cartContainer.setAttribute('data-active', 'false');

  toggleDataActive('.cart-close', '#shopify-section-side-cart', {
    overlay: true,
  });

  toggleDataActive('.button-cart', '#shopify-section-side-cart', {
    overlay: true,
  });
};

barProgressReward($Q('#data-reward'));
